import { LogoModal, createEventLogoConfig } from "@/components/logo-modal";

interface EventLogoModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  eventId: number;
  eventName: string;
  currentLogoUrl?: string | null;
}

export function EventLogoModal({
  isOpen,
  onOpenChange,
  eventId,
  eventName,
  currentLogoUrl,
}: EventLogoModalProps) {
  const config = createEventLogoConfig(eventId, eventName);
  
  return (
    <LogoModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      config={config}
      currentLogoUrl={currentLogoUrl}
    />
  );
}